export default "__VITE_ASSET__CRs$owv0__"